import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import ENDPOINTS from '../../api/endPoints';
import {
  fetchUpcomingEventsRequest,
  fetchUpcomingEventsSuccess,
  fetchUpcomingEventsFailure,
} from '../slices/upcomingEventsSlice';
import type {
  UnifiedEventsResponse,
} from '../../components/upcomingEvents/types';

function* fetchUpcomingEventsSaga(
  action: PayloadAction<{ restaurantId: string; countryCode: string }>
): Generator<any, void, any> {
  try {
    const { countryCode } = action.payload;

    // Call unified events API - no headers needed as per requirements
    const response = yield call(
      axios.get,
      ENDPOINTS.unifiedEvents
    );

    // Parse response
    const eventsData: UnifiedEventsResponse = response.data;

    // Dispatch success with unified events data
    yield put(
      fetchUpcomingEventsSuccess({
        unifiedEvents: eventsData.data || [],
      })
    );
  } catch (error: any) {
    yield put(
      fetchUpcomingEventsFailure(
        error.response?.data?.message || error.message || 'Failed to fetch upcoming events'
      )
    );
  }
}

export function* upcomingEventsSaga() {
  yield takeLatest(fetchUpcomingEventsRequest.type, fetchUpcomingEventsSaga);
}
